
import { Component } from '@angular/core';
import { ActivatedRoute, Router, RouterLink } from '@angular/router';
import { ChatbotConfig } from '@shared/index';
import dayjs from 'dayjs';
import { ConfirmationService, MenuItem } from 'primeng/api';
import { Button, ButtonModule } from 'primeng/button';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { IconFieldModule } from 'primeng/iconfield';
import { InputIconModule } from 'primeng/inputicon';
import { InputTextModule } from 'primeng/inputtext';
import { Popover } from 'primeng/popover';
import { TableModule } from 'primeng/table';
import { TagModule } from 'primeng/tag';
import { BotIconComponent } from 'src/app/shared/components/bot-icon/bot-icon.component';
import { AdminService } from '@shared-angular/services/admin.service';
import { BotService } from 'src/app/shared/services/bot.service';
import { LanguageService } from '@shared-angular/services/language.service';
import { LoginService } from '@shared-angular/services/login.service';

@Component({
  selector: 'app-templates-page',
  imports: [RouterLink, BotIconComponent,
    TableModule,
    ButtonModule,
    InputTextModule,
    IconFieldModule,
    InputIconModule,
    Popover,
    ConfirmDialogModule,
    TagModule
],
  standalone: true,
  providers: [ConfirmationService],
  templateUrl: './templates-page.component.html',
  styleUrl: './templates-page.component.scss'
})
export class TemplatesPageComponent {
  public bots!: ChatbotConfig[];
  public dayjs = dayjs;
  public contextMenu: (MenuItem & { command: () => void })[] = [];
  private activePop: Popover | null = null;

  constructor(
    public aRoute: ActivatedRoute,
    public adminService: AdminService,
    public loginService: LoginService,
    public botService: BotService,
    private router: Router,
    private langService: LanguageService,
    private confirmationService: ConfirmationService
  ) {
    this.aRoute.data.subscribe((data) => {
      this.bots = (data as unknown as { bots: ChatbotConfig[] }).bots;
    });
  }

  public openMenu(event: MouseEvent, popover: Popover, bot: ChatbotConfig, button: Button) {
    if (this.activePop && this.activePop !== popover) {
      this.activePop.hide();
    }
    this.contextMenu = this.getMenuItems(bot);
    popover.toggle(event, button.el.nativeElement);
    this.activePop = popover;
  }

  private getMenuItems(bot: ChatbotConfig) {
    const menu: (MenuItem & { command: () => void })[] = [];

    menu.push({
      label: $localize`:@@edit-template:Vorlage bearbeiten`,
      icon: 'ri ri-pencil-line',
      command: () => {
        void this.router.navigate(['/', 'bot-admin', bot._id, 'task']);
      }
    });

    menu.push({
      label: $localize`:@@delete-template:Vorlage löschen`,
      icon: 'ri ri-delete-bin-line',
      command: () => {
        this.confirmDeleteTemplate(bot);
      }
    });

    return menu;
  }

  private confirmDeleteTemplate(bot: ChatbotConfig) {
    this.confirmationService.confirm({
      header: $localize`:@@confirm-delete-template-header:Vorlage löschen?`,
      icon: 'ri-error-warning-line',
      message: $localize`:@@confirm-delete-template-message:Möchtest du die Vorlage „${bot.name}" unwiderruflich löschen? Diese Aktion kann nicht rückgängig gemacht werden.`,
      rejectButtonProps: {
        label: $localize`:@@cancel:Abbrechen`,
        severity: 'secondary',
        outlined: true
      },
      acceptButtonProps: {
        label: $localize`:@@delete-permanently:Endgültig löschen`,
        severity: 'danger'
      },
      accept: async () => {
        await this.adminService.deleteBot(bot._id);
        this.bots = this.bots.filter(b => b._id !== bot._id);
      },
      reject: () => {
        this.confirmationService.close();
      }
    });
  }
}
